import { c as _c } from "react/compiler-runtime";
import { Accordion } from '@systemeio/components';
import { ReactNode } from 'react';
const DISCLOSURE_ITEM_VALUE = 'content';
export interface DisclosureBoxProps {
  actions?: ReactNode;
  children?: ReactNode;
  defaultOpen?: boolean;
  description?: ReactNode;
  disabled?: boolean;
  invalid?: boolean;
  label: ReactNode;
}
export function DisclosureBox(t0) {
  const $ = _c(30);
  const {
    actions,
    children,
    defaultOpen,
    description,
    disabled,
    invalid,
    label
  } = t0;
  const hasActions = actions !== undefined;
  const t1 = invalid || undefined;
  let t2;
  if ($[0] !== hasActions) {
    t2 = hasActions && <Accordion.Chevron />;
    $[0] = hasActions;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label) {
    t3 = <span className="min-w-0 flex-1 truncate">{label}</span>;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== description) {
    t4 = description !== undefined && <span className="text-text-link shrink-0">{description}</span>;
    $[4] = description;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== hasActions) {
    t5 = !hasActions && <Accordion.Chevron />;
    $[6] = hasActions;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== disabled || $[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <Accordion.Header><Accordion.Trigger aria-invalid={t1} disabled={disabled}>{t2}{t3}{t4}{t5}</Accordion.Trigger></Accordion.Header>;
    $[8] = disabled;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const header = t6;
  let t7;
  if ($[15] !== defaultOpen) {
    t7 = defaultOpen ? [DISCLOSURE_ITEM_VALUE] : undefined;
    $[15] = defaultOpen;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const t8 = invalid ? "border-border-error" : undefined;
  let t9;
  if ($[17] !== actions || $[18] !== hasActions || $[19] !== header) {
    t9 = hasActions ? <Accordion.HeaderRow>{header}<Accordion.Actions>{actions}</Accordion.Actions></Accordion.HeaderRow> : header;
    $[17] = actions;
    $[18] = hasActions;
    $[19] = header;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== children) {
    t10 = <Accordion.Panel><Accordion.Content>{children}</Accordion.Content></Accordion.Panel>;
    $[21] = children;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t8 || $[25] !== t9) {
    t11 = <Accordion.Item className={t8} value={DISCLOSURE_ITEM_VALUE}>{t9}{t10}</Accordion.Item>;
    $[23] = t10;
    $[24] = t8;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t7) {
    t12 = <Accordion.Root defaultValue={t7}>{t11}</Accordion.Root>;
    $[27] = t11;
    $[28] = t7;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
}